import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportEmployeesUploadCvs } from '@/components/pages/Employees/Import'
import ImportPageHeader from '@/components/pages/ImportPageHeader'

import { useImportWashingMethod } from './Import.hooks'

const ImportWashingMethod: VFC = () => {
  const { importWashingMethod, loading } = useImportWashingMethod()
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = { codeIdx: 0, nameIdx: 1, volumeIdx: 2, timeIdx: 3, costIdx: 4 }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importWashingMethod(formData)
    }
  }

  return (
    <>
      <ImportPageHeader title={t('pages.washingMethods.importFromCsv.title')} />
      <ImportEmployeesUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportWashingMethod.displayName = 'ImportWashingMethod'
export default ImportWashingMethod
